import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ACCESS_TOKEN_KEY, USER_KEY } from '@/constants'
import { userApi } from '@/services/api'
import { LoginUser, User } from '@/types'
import { getToken, isValid } from '@/utils'

import { RootState } from '.'

const me = () => {
  const str = localStorage.getItem(USER_KEY)
  if (!str) return null
  return JSON.parse(str) as User
}

const initialState: {
  user: User | LoginUser | null
  loading: boolean
  token: string | null
} = {
  user: me(),
  loading: false,
  token: getToken(),
}

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    saveToken(state, action: PayloadAction<string | null | undefined>) {
      const token = action.payload
      if (token && isValid(token)) {
        localStorage.removeItem(ACCESS_TOKEN_KEY)
        localStorage.setItem(ACCESS_TOKEN_KEY, token)
        state.token = token
      }
    },
    logout(state) {
      localStorage.removeItem(ACCESS_TOKEN_KEY)
      localStorage.removeItem(USER_KEY)
      state.user = null
      state.token = null
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(userApi.endpoints.login.matchPending, (state) => {
      state.loading = true
    })
    builder.addMatcher(userApi.endpoints.login.matchFulfilled, (state, { payload }) => {
      const { token, user } = payload

      if (token && isValid(token)) {
        state.token = token
        state.user = user

        localStorage.setItem(ACCESS_TOKEN_KEY, token)
        localStorage.setItem(USER_KEY, JSON.stringify(user))
      }

      state.loading = false
    })
    builder.addMatcher(userApi.endpoints.login.matchRejected, (state) => {
      state.loading = false
    })
    builder.addMatcher(userApi.endpoints.getUser.matchPending, (state) => {
      state.loading = true
    })
    builder.addMatcher(userApi.endpoints.getUser.matchFulfilled, (state, { payload }) => {
      state.user = payload
      localStorage.setItem(USER_KEY, JSON.stringify(payload))
      state.loading = false
    })
    builder.addMatcher(userApi.endpoints.getUser.matchRejected, (state) => {
      state.loading = false
    })
  },
})

export const { logout, saveToken } = accountSlice.actions

export const accountSelector = (state: RootState) => state.account

export default accountSlice.reducer
